import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMergeCustom = extendTailwindMerge({
	extend: {
		classGroups: {
			'font-size': [
				{
					text: [
						'display-large',
						'display-medium',
						'display-small',
						'headline-xx-large',
						'headline-xx-large2',
						'headline-x-large',
						'headline-large',
						'headline-medium',
						'headline-small',
						'headline-x-small',
						'title-large',
						'title-large2',
						'title-medium',
						'title-medium2',
						'title-small',
						'title-small2',
						'body-large',
						'body-medium',
						'body-small',
						'body-x-small',
						'body-x-small2',
						'body-xx-small',
						'label-large',
						'label-large2',
						'label-semibold',
						'label-medium',
						'label-small',
						'label-small2',
						'label-x-small',
						'label-xx-small',
						'caption',
						'table-header',
					],
				},
			],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return twMergeCustom(clsx(inputs));
}
